module.exports = __webpack_public_path__ + "img/icon_map_xg_c.67d014b6.png";